import { Component, DestroyRef, EventEmitter, inject, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InternalUserAuthViewModel } from './internal-user-auth-view-model.service';
import { InternalUserAuthFlow } from '../../../../../models/users/enum/internal-user-auth-flow.enum';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-internal-user-auth',
  templateUrl: './internal-user-auth.component.html',
  providers: [InternalUserAuthViewModel],
  styleUrls: ['./internal-user-auth.component.scss']
})
export class InternalUserAuthComponent {
  private route = inject(ActivatedRoute);
  private viewModel = inject(InternalUserAuthViewModel);
  private destroyRef = inject(DestroyRef);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  public showBackButton$ = this.viewModel.showBackButton$;
  public authFlow$ = this.viewModel.authFlow$;

  private listenToLoadingOpts = this.viewModel.loadingOpts$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(opts => this.loadingOpts.emit(opts));

  private listenToUrl = this.route.url.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
    next: url => {
      switch (url[url.length - 1].path) {
        case 'sign-in': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.SignIn);
          break;
        }
        case 'forgot-password': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.ForgotPassword);
          break;
        }
        case 'reset-password': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.ResetPassword);
          break;
        }
        case 'new-password': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.SetNewPassword);
          break;
        }
        case 'internal-user-auth-setup': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.InternalUserSetupMfa);
          break;
        }
        case 'internal-user-choose-password': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.InternalUserChoosePassword);
          break;
        }
        case 'internal-user-verify-code': {
          this.viewModel.setAuthFlow(InternalUserAuthFlow.InternalVerifyCode);
          break;
        }
      }
    }
  });

  public goBack(): void {
    this.viewModel.goBack();
  }

  protected readonly InternalUserAuthFlow = InternalUserAuthFlow;
}
